export default {
    clientCount: 'Client count',
    createGroup: 'Create Group',
    createRole: 'Create Role',
    groupName: 'Group name',
    groups: 'Groups',
    memberCount: 'Member count',
    noGroups:
        "You haven't created any groups yet. Create a group to control visibility of documents and clients.",
    noRoles:
        "You haven't created any roles yet. Create roles to replicate your company's functional structure.",
    roleName: 'Role Name',
    roles: 'Roles',
    subtitleGroups:
        'Documents and clients owned by a group are only visible to members of the group',
    subtitleRole:
        'Assign team members to different functional roles within your company',
};
